import { render, staticRenderFns } from "./accountAuthorization.vue?vue&type=template&id=775a7679&scoped=true"
import script from "./accountAuthorization.vue?vue&type=script&lang=js"
export * from "./accountAuthorization.vue?vue&type=script&lang=js"
import style0 from "./accountAuthorization.vue?vue&type=style&index=0&id=775a7679&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775a7679",
  null
  
)

export default component.exports